import type { SvgIconComponent } from "@mui/icons-material";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import FactoryIcon from "@mui/icons-material/Factory";
import HomeIcon from "@mui/icons-material/Home";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export interface NavItem {
  label: string;
  icon: SvgIconComponent;
  to: string;
}

export const PID_EXPLORER_PATH = "/dashboard/pid-explorer";

export const NAV_ITEMS: NavItem[] = [
  { label: "Fleet Overview", icon: HomeIcon, to: "/dashboard" },
  { label: "Plants", icon: FactoryIcon, to: "/dashboard/plants" },
  { label: "SPOFs", icon: WarningAmberIcon, to: "/dashboard/spofs" },
  {
    label: "P&ID Explorer",
    icon: AccountTreeIcon,
    to: PID_EXPLORER_PATH,
  },
];
